import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(({
	titleText: {
		fontSize: "32px",
		lineHeight: "24px",
		color: colors.gray[800]
	},
	paper: {
		width: "100%"
	},
	dateContainer: {
		flex: 1,
		padding: 0,
		width: "180px",
		margin: 0
	},
	dateInput: {
		paddingLeft: "0px",
		marginRight: "0px",
		fontSize: "14px",
		height: "40px"
	},
	dateButton: {
		paddingLeft: "9px",
		paddingRight: "9px"
	},
	tagFilter: {
		minWidth: "250px",
		overflowY: "auto",
		maxHeight: 160,
		maxWidth: "500px",
		"&::-webkit-scrollbar": {
			width: "0.3em"
		},
		"&::-webkit-scrollbar-track": {
		},
		"&::-webkit-scrollbar-thumb": {
			border: "none",
			outline: 1,
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[100])
		}
	}
}))

export default useStyles
